// The search field is rendered inside owc-base-dropdown, so its keystrokes bubble up into the
// dropdown's KeydownManager. That manager claims these keys for list navigation and calls
// preventDefault on them, so the keystroke never reaches the field: no space can be typed and the
// caret cannot jump to either end. Keys that type or move the caret belong to the field; the ones
// that navigate the list (arrows up/down), commit (Enter) or close it (Escape) stay with the dropdown.
const TEXT_EDITING_KEYS = [' ', 'Home', 'End', 'ArrowLeft', 'ArrowRight'];

export const keepTextEditingKeysInInput = (event: KeyboardEvent) => {
    if (TEXT_EDITING_KEYS.includes(event.key)) {
        event.stopPropagation();
    }
};
